import React, {useEffect, useState} from 'react'
import { Tabs } from 'antd'
import ReactDOM from 'react-dom'
import { ajaxApi } from '../../../server/index'
import {getParmUrl,getCookieNew} from '../../../public/utils'
import _lodash from 'lodash'
import common from '@/public/common'
import CommodityInformation from './commodity-information'
import SixFacesChart from './six-faces-chart'
import CooperationInformation from './cooperation-information'
import ApprovalInformation from './approval-information'
const { TabPane } = Tabs
let urlslinks = ''
const DetailsInfomation = () => {
  const [detailsData, setdetailsData] = useState({
    'item_info': {
      'is_cross_border': null,
      'brand_id': null,
      'brand_name': '',
      'category_id': null,
      'category_name': '',
      'item_color_type': '',
      'item_series': '',
      'english_name': '',
      'creater': getCookieNew('supplier_code')|| null,
      'create_ch': getCookieNew('supplier_company_name') || null,
      'create_time': null,
      'spec': '',
      'spec_unit': '',
      'item_material': '',
      'item_useful_life': null,
      'useful_unit': '',
      'is_customed': null,
      'weight': null,
      'packing_specification': '',
      'logistics_service': '',
      'origin_place': '',
      'create_company': '',
      'operation': '',
      'is_one_sale': null,
      'distribute_type': '',
      'distribute_number': null,
      'promote_desc': '',
      'purchase_desc': '',
      'pay_type': '',
      'pay_day': null,
      'pay_cycle': '',
      'tax_rate': null,
      'after_sale_problem': '',
      'settle_price': null,
      'price_unit': '',
      'produce_cycle': null,
      'delivery_day': null,
      'sale_price': null,
      'is_supply_complaint': null,
      'is_rebate': '',
      'rebate_type': '',
      'rebate_point': null,
      'rebate_base': '',
      'rebate_note': '',
      'gross_rate': null,
      'gross_money': null,
      'rebate_cost': null
    },
    'extend_propertys': [
      {
        'property_id': null,
        'property_name': '',
        'extend_value': '',
        'property_type': '',
        'is_required': null
      }
    ],
    'sku_propertys': [
      {
        'property_id': null,
        'property_name': '',
        'sku_value': [],
        'property_type': '',
        'is_required': null
      }
    ],
    'contact_property': {
      'change_cycle': '',
      'water': '',
      'refraction': '',
      'oxygen': '',
      'first_thickness': '',
      'second_thickness': '',
      'third_thickness': ''
    },
    'color_propertys': [],
    'degrees': [],
    'six_images': [],
    'checks': []
  })
  const [iframeurl, setiframeurl] = useState('')
  const [issecond, setissecond] = useState(false)
  // 获取详情
  const getDetailsData = async () => {
    const res = await ajaxApi({
      url: common.scpUrl + 'item/query-detail',
      params: {id: getParmUrl('id') || null}
    })
    if (res.status === 200) {
      setdetailsData(res.data)
      var detailsData = {...res.data, qualificationurl: urlslinks}
      _lodash.set(detailsData,'extend_propertys',_lodash.reject(_lodash.get(detailsData,'extend_propertys',[]),['property_name','ContactsType']))
      sessionStorage.setItem('detailsData', JSON.stringify(detailsData))
    }
  }

  useEffect(() => {
    if (getParmUrl('id')) {
      let params = JSON.parse(sessionStorage.getItem('detailsData'))
      if (params.qualificationurl) {
        setiframeurl(params.qualificationurl + '&ishidemenu=true')
        // eslint-disable-next-line no-const-assign
        urlslinks = params.qualificationurl
      }
      if (params.item_info && params.item_info.import_part === 'second') {
        setissecond(true)
      } else {
        setissecond(false)
      }
      getDetailsData()
    }
  }, [])

  return (
    <div className="addGood">
      <div className="search">
        <div style={{width: '100%', margin: '0 auto'}}>

          {detailsData && detailsData.checks.length !== 0
            ? <Tabs defaultActiveKey="1" >
              <TabPane tab="审批详情展示" key="1">
                <ApprovalInformation />
              </TabPane>
              <TabPane tab="商品基本信息" key="2">
                <CommodityInformation />
              </TabPane>
              <TabPane tab="六面图" key="3">
                <SixFacesChart />
              </TabPane>
              <TabPane tab="合作政策" key="4">
                <CooperationInformation />
              </TabPane>
              {iframeurl && issecond ? <TabPane tab="查看资质" key="5">
                <iframe allowfullscreen="true" name="mainIframe" width="100%" height={700} loading="auto" src={iframeurl} frameBorder="0" scrolling="auto" ></iframe>
              </TabPane> : null}
            </Tabs>
            : <Tabs defaultActiveKey="1" >
              <TabPane tab="商品基本信息" key="1">
                <CommodityInformation detailsdata={detailsData}/>
              </TabPane>
              <TabPane tab="六面图" key="2">
                <SixFacesChart />
              </TabPane>
              <TabPane tab="合作政策" key="3">
                <CooperationInformation />
              </TabPane>
              {iframeurl && issecond ? <TabPane tab="查看资质" key="5">
                <iframe allowfullscreen="true" name="mainIframe" width="100%" height={700} loading="auto" src={iframeurl} frameBorder="0" scrolling="auto" ></iframe>
              </TabPane> : null}
            </Tabs>
          }
        </div>
      </div>
    </div>
  )
}

export default DetailsInfomation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/newproductdetails/details-infomation.js